import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../../common/api/request';
import { UploadResponse } from './types';

interface UploadMutationOptions {
  onSuccess?: (data: UploadResponse) => void;
  onError?: (error: any) => void;
}

export function useSamplingPlanningUpload(options?: UploadMutationOptions) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (file: File): Promise<UploadResponse> => {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post('/sampling-planning/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    },
    onSuccess: (data) => {
      // Invalidate and refetch sampling planning data
      queryClient.invalidateQueries({ queryKey: ['sampling-planning-data'] });
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
} 